import React from "react";
import { useState } from "react";
import { Card, Row, Col, List, Button } from "antd";
import { CheckSquareTwoTone, CloseSquareTwoTone } from "@ant-design/icons";
import { toast } from "../../../utils/toasts";
import { handleError } from "../../../utils/errorHandler";
import { generateFolder } from "../../../api/cartransferService";

const fields = [
  {
    title: "Cédula vendedor",
    field: "folder_seller",
  },
  {
    title: "Cédula comprador",
    field: "folder_buyer",
  },
  {
    title: "Certificado de antecedentes",
    field: "folder_background",
  },
  {
    title: "Permiso de circulación",
    field: "folder_permission",
  },
  {
    title: "Contrato de compraventa",
    field: "folder_contract_original",
  },
  {
    title: "Contrato de compraventa firmado",
    field: "folder_contract_signed",
  },
  {
    title: "Comprobante pago F23",
    field: "folder_f23_payment",
  },
  {
    title: "Cert. Movimientos",
    field: "folder_movements",
  },
  {
    title: "Comprobante SII",
    field: "folder_sii_cert",
  },
  {
    title: "Solicitud de ingreso registro civil",
    field: "folder_rc_inscription",
  },
];

const CartransferFolderForm = ({ cartransfer }) => {
  const [loading, setLoading] = useState(false);

  //this function could be centralized (ie handle all this try catch stuff in one place)
  const handleFolderButton = async () => {
    setLoading(true);
    if (cartransfer.folderUrl) {
      window.open(cartransfer.folderUrl);
    } else {
      try {
        const response = await generateFolder(
          cartransfer.id
        );
        window.open(response.data);
      } catch (error) {
        handleError(error, toast, "Error al generar carpeta", "generateFolder");
      }
    }
    setLoading(false);
  };
  return (
    <Card
      title={`Carpeta repertorio ${cartransfer.repertory}-${cartransfer.repertoryYear}`}
    >
      <List
        size="large"
        footer={
          <Button onClick={handleFolderButton} type="primary" loading={loading}>
            {cartransfer.folderUrl ? "Descargar carpeta" : "Generar carpeta"}
          </Button>
        }
        dataSource={fields}
        renderItem={(item) => (
          <List.Item>
            {cartransfer[item.field] ? (
              <Row gutter={16}>
                <Col>
                  <CheckSquareTwoTone
                    twoToneColor="#52c41a"
                    style={{ padding: 5 }}
                  />
                </Col>
                <Col>
                  <a target="_blank" rel="noreferrer" href={cartransfer[item.field]}>
                    {item.title}
                  </a>
                </Col>
              </Row>
            ) : (
              <Row gutter={16}>
                <Col>
                  <CloseSquareTwoTone twoToneColor="red" />
                </Col>
                <Col>{item.title}</Col>
              </Row>
            )}
          </List.Item>
        )}
      />
    </Card>
  );
};

export default CartransferFolderForm;
